import React from 'react'
import { Link, useSearchParams } from 'react-router-dom';
import { useStoresInCompleteByAdmin } from '../../../hooks/admin/store.admin';
import LoadingErrorState from '../../ui/LoadingErrorState';
import Pagination from '../../ui/Pagination';
import EmptyData from '../../ui/EmptyData';
import { useTranslation } from 'react-i18next';

function InCompletesStoresView() {
    const [searchParams,setSearchParams] = useSearchParams();
    const pageQuery = Number(searchParams.get('page')) || 1;
    const {data,isLoading , isError} = useStoresInCompleteByAdmin({page:pageQuery});
     const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };


        const {t} = useTranslation();
  return (
    <div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
        {
        (data) ?
        <>
        <div className="overflow-x-auto">
        <table className="w-full border-separate border-spacing-y-5">
            <thead>
                <tr className="text-start text-sm text-DarkGrey2 font-semibold">
                    <th className="p-3 font-normal capitalize">{t("id")}</th>
                    <th className="p-3 font-normal capitalize">{t("brand_name_en")}</th>
                    <th className="p-3 font-normal capitalize">{t("brand_name_ar")}</th>
                    <th className="p-3 font-normal capitalize">{t("owner_name")}</th>
                    <th className="p-3 font-normal capitalize">{t("actions")}</th>
                </tr>
            </thead>
            <tbody className="text-sm">
                {data.stores.map((store) => {
                    const arabicName = store.languages.find(lang => lang.languageCode === "ar")?.brand || "-";
                    const englishName = store.languages.find(lang => lang.languageCode === "en")?.brand || "-";

                    return (
                    <tr key={store.owner.id} className="border-b border-muted">
                        <td className="p-3">{store.id}</td>
                        <td className="p-3">{englishName}</td>
                        <td className="p-3">{arabicName}</td>
                        <td className="p-3">{store.owner.name}</td>
                        <td className="p-3">
                        <Link
                            to={`/admin/owners/${store.owner.id}`}
                            className="text-primary hover:underline"
                        >
                            {t("view_details_owner")}
                        </Link>
                        </td>
                    </tr>
                    );
                })}
            </tbody>
        </table>
        </div>
        <div>
            <Pagination
                handlePagination={handlePagination}
                totalPages={data.totalPages}
                currentPage={pageQuery}
            />
          </div>
        </>
        :
        !isLoading ?<EmptyData/>:""
      }
    </div>
  )
}

export default InCompletesStoresView